"use strict";

const {
  init
} = require('./init');
const Configuration = require('./configuration');
const Globals = require('./globals');
const ConsentManager = require('./consentManager');
function initialize(writeKey, integrations, tenant, culture, sourceMiddlewares, destinationMiddlewares, suppressReloadOnConsentSubmit, onError, consentManagerCssClassNames, disableWebVitals) {
  initializeInternal(writeKey, integrations, tenant, culture, sourceMiddlewares, destinationMiddlewares, suppressReloadOnConsentSubmit, undefined, onError, consentManagerCssClassNames, disableWebVitals);
}
function initializeWithData(prefetchedData, config) {
  if (!prefetchedData) {
    throw new Error('Missing prefetchedData for tracking');
  }
  config = config || {};
  initializeInternal(prefetchedData.writeKey, config.integrations, prefetchedData.tenant, prefetchedData.culture, config.sourceMiddlewares, config.destinationMiddlewares, config.suppressReloadOnConsentSubmit, prefetchedData.consentData, config.onError, config.consentManagerCssClassNames, config.disableWebVitals);
}
function initializeInternal(writeKey, integrations, tenant, culture, sourceMiddlewares, destinationMiddlewares, suppressReloadOnConsentSubmit, consentData, onError, consentManagerCssClassNames, disableWebVitals) {
  if (onError && typeof onError !== 'function') {
    throw new Error('onError is not function');
  }
  integrations = Configuration.ensureIntegrations(integrations);
  const config = Configuration.applyOverride(writeKey, integrations, tenant, culture, sourceMiddlewares, destinationMiddlewares, suppressReloadOnConsentSubmit, onError, consentManagerCssClassNames, disableWebVitals);
  const tracking = init(config, () => {
    ConsentManager.init(config.writeKey, config.tenant, config.culture, config.suppressReloadOnConsentSubmit, config.consentManagerCssClassNames, consentData);
  });
  Globals.setTracking(tracking);
}
function getTracking() {
  return Globals.getTracking();
}
module.exports = {
  init: initialize,
  initWithData: initializeWithData,
  getTracking: getTracking
};